export default __webpack_public_path__ + "static/media/assistant.d3bfaff6.svg";